import { ChangeDetectorRef, Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { LinkedTemplateListComponent } from '../linked-templates/edit-add-linked-template-popup/linked-template-list/linked-template-list.component';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { DocumentService } from '@app/shared/services/vault/document.service';
import { ConfigurationType } from '@app/shared/component/manage-element/manage-combo-element/enum';
import { FileNameWithoutExtension } from '@app/shared/pipes/file-name-without-extension.pipe';
import { SuggestionType } from '@app/shared/component/common-suggestion-view/suggestion';
import { GetFileExtension } from '@app/shared/pipes/get-file-extension.pipe';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConnectToMxComponent } from '@app/modules/vault/mx-component/dialog/connect-to-mx/connect-to-mx.component';
import { MxTaskbarService } from '@app/shared/services/mx-taskbar/mx-taskbar.service';
import { AddDocumentComponent } from '../add-document.component';
import { EditMxPlayerComponent } from '../add-api-key-managed/edit-mx-player/edit-mx-player.component';
import * as vaultSelectors from '@app/root-store/vault-store/vault.selector';
import { EventNames } from '@app/constants/events.constants';
import { UserService } from '@app/shared/services/user/user.service';
import { DialogEventService } from '@app/shared/services';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'app-linked-template-method',
  templateUrl: './linked-template-method.component.html',
  providers: [FileNameWithoutExtension, GetFileExtension],
})
export class LinkedTemplateMethodComponent implements OnInit, OnDestroy {
  @ViewChild(LinkedTemplateListComponent) linkedTemplateList: LinkedTemplateListComponent;
  @Input() data: any;
  @Input() root_form_type_template: any;
  @Input() formsList: any;
  @Input() currentFormId: any;
  @Input() currentUserId: any;
  @Input() isRemoveEditSaveSharing = false;
  @Input() selectedLinkType: 'Payment Method' | 'Linked Payment Method' | 'Secured By' | 'Loans Secured' | string = '';
  @Output() linkedTemplateSelectionChange = new EventEmitter<{
    template: any;
    index: number;
    isChecked: boolean;
    linkType: string;
  }>();
  cd: ChangeDetectorRef = inject(ChangeDetectorRef);
  private store: Store = inject(Store);
  private documentService: DocumentService = inject(DocumentService);
  private fileNameWithoutExtension: FileNameWithoutExtension = inject(FileNameWithoutExtension);
  private getFileExtension: GetFileExtension = inject(GetFileExtension);
  private mxTaskbarService: MxTaskbarService = inject(MxTaskbarService);
  private dialog: MatDialog = inject(MatDialog);
  private userService: UserService = inject(UserService);
  private dialogEventService: DialogEventService = inject(DialogEventService);
  is_Group = false;
  searchText: string = '';
  templateConfigurationList: any[] = [];
  linkedTemplate: any[] = [];
  unlinkedTemplate: any[] = [];
  subscription = new Subscription();
  isLinkedFileLoading = true;
  suggestionData = [];
  formTypeData = [];
  filterConfiguration = [];
  group_templateConfigurationList = [];
  linkedRecordItem = {};
  linkedLocation = false;
  isUnLinkedFileLoading = true;
  screenWidth: number;

  ngOnInit(): void {
    this.screenWidth = window.innerWidth;

    this.linkedRecordItem = {
      is_running: false,
      suggestion_icon_pth: 'assets/images/linked-folder/linked-suggestion.svg',
      vault_folder_type_linked: true,
      label:
        this.selectedLinkType == 'Payment Method'
          ? 'Linked Payment Methods'
          : this.selectedLinkType == 'Linked Payment Method'
          ? 'Payment Method For'
          : this.selectedLinkType == 'Secured By'
          ? 'Loans Secured'
          : 'Secured By',
      type_template:
        this.selectedLinkType == 'Payment Method'
          ? 'PaymentMethod'
          : this.selectedLinkType == 'Linked Payment Method'
          ? 'LinkedPaymentMethod'
          : this.selectedLinkType == 'Secured By'
          ? 'SecuredBy'
          : this.selectedLinkType == 'Loans Secured'
          ? 'LoansSecured'
          : '',
      type:
        this.selectedLinkType == 'Payment Method'
          ? 'PaymentMethod'
          : this.selectedLinkType == 'Linked Payment Method'
          ? 'LinkedPaymentMethod'
          : this.selectedLinkType == 'Secured By'
          ? 'SecuredBy'
          : this.selectedLinkType == 'Loans Secured'
          ? 'LoansSecured'
          : '',
      icon_path: 'assets/images/linked-folder/linked-suggestion.svg',
      template_list: [],
      is_linked: false,
      show_onboarding: false,
      allowedOne: null,
      link_onlyOne: null,
    };
    this.data = {
      ...this.data,
      ...this.linkedRecordItem,
    };
    this.getLinkedForms();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  selectConnectedUser(event) {
    const type =
      this.selectedLinkType == 'Secured By' ? 'LoansSecured' : this.selectedLinkType == 'Loans Secured' ? 'SecuredBy' : this.data?.type_template;

    let payload = {
      user_id: this.currentUserId,
      vault_user_form_id: this.currentFormId,
      created_by_user_id: this.currentUserId,
      association_type: type,
      associate_vault_user_form_id: event.id,
    };

    this.subscription.add(
      this.documentService.createUserFormAssociation(payload).subscribe(
        (res) => {
          this.trackEventsInMixPanel([
            {
              eventName: 'add',
              data: {
                form_name: res.form_name,
                template_name: this.data.formName,
                vault_form_type: res.vault_form_type,
                type_template: this.data.type_template,
              },
            },
          ]);

          this.getLinkedForms();
          this.cd.detectChanges();
        },
        (error) => {
          this.cd.detectChanges();
        }
      )
    );
    this.cd.markForCheck();
  }

  getLinkedForms() {
    this.isLinkedFileLoading = true;
    const sub_type =
      this.selectedLinkType == 'Payment Method'
        ? 'PaymentMethod'
        : this.selectedLinkType == 'Linked Payment Method'
        ? 'LinkedPaymentMethod'
        : this.selectedLinkType == 'Secured By'
        ? 'LoansSecured'
        : this.selectedLinkType == 'Loans Secured'
        ? 'SecuredBy'
        : '';
    const type =
      this.selectedLinkType == 'Secured By' ? 'LoansSecured' : this.selectedLinkType == 'Loans Secured' ? 'SecuredBy' : this.data?.type_template;
    let data = {
      user_id: this.currentUserId,
      vault_user_form_id: this.currentFormId,
      type_template_list: this.data?.template_list,
      type,
      vault_user_form_ids: this.data?.selectedItemsArray?.map((item) => item?.vault_user_form_id) ?? [],
      sub_type: sub_type,
    };

    this.subscription.add(
      this.documentService
        .getFormsLinkingSearch({
          type,
          user_id: this.currentUserId,
          vault_user_form_id: this.currentFormId,
        })
        .subscribe(
          (res) => {
            this.modifySuggestionData(res);
            this.cd.detectChanges();
          },
          (error) => {
            this.cd.detectChanges();
          }
        )
    );

    this.subscription.add(
      this.documentService.getFormsLinked(data).subscribe(
        (res) => {
          this.linkedTemplate = res?.data?.data ?? res?.data ?? [];
          this.linkedTemplate.forEach((template) => {
            const matchTemplateExist = this.data?.formsList?.find((form) => form.type === template.vault_form_type);
            if (matchTemplateExist) {
              template.api_source = matchTemplateExist?.api_source;
            }
          });
          this.isLinkedFileLoading = false;
          this.cd.detectChanges();
        },
        (error) => {
          this.isLinkedFileLoading = false;
          this.cd.detectChanges();
        }
      )
    );
  }
  modifySuggestionData(res) {
    this.isUnLinkedFileLoading = true;
    this.unlinkedTemplate = res;
    this.suggestionData = [];
    this.formTypeData = [];
    if (this.linkedLocation) {
      if (this.data?.label == 'Items In This Location') {
        this.filterConfiguration = [];
        this.filterConfiguration.push({
          data: res?.filter((x) => x.origin),
          key: ConfigurationType.TEMPLATE,
          label: 'Templates',
          placeHolder: 'Search Template',
          selectedData: this.linkedTemplate,
          templateConfigurationList: [],
        });
        let attachment_list = [];
        res.forEach((element) => {
          if (!element?.origin) {
            let newElement = {
              ...element,
              form_name: this.fileNameWithoutExtension.transform(element.display_file_name),
              type: this.getFileExtension.transform(element.display_file_name),
            };
            attachment_list.push(newElement);
          }
        });
        this.filterConfiguration.push({
          data: attachment_list,
          key: ConfigurationType.TEMPLATE,
          label: 'Attachments',
          placeHolder: 'Search Attachments',
          selectedData: this.linkedTemplate,
          templateConfigurationList: [],
        });
      }
    } else {
      this.formTypeData = [];
      this.templateConfigurationList.forEach((element, index) => {
        let filterData = res?.filter((x) => x.type == element.type);

        let findTemplateType = this.data.template_list.find((x) => x.templateType == element.type);

        let filterList = this.data?.template_list?.filter((x) => x.templateType == element.type);
        let suggestionFile = [];
        filterData?.forEach((filterDataElement) => {
          suggestionFile.push({
            id: filterDataElement.id,
            name: filterDataElement.form_name,
            type: filterDataElement.type,
            profile_image_url: filterDataElement.profile_image_url,
            vault_form_id: filterDataElement.vault_form_id,
            vfid: filterDataElement.id,
          });
        });
        if (filterList.length > 1) {
          filterList.forEach((item) => {
            this.formTypeData.push({
              id: element.id,
              type: element.type,
              image: element.image,
              displayType: item.templateSubType,
              entityData: suggestionFile,
              isCustomImg: true,
              img: element.image,
            });
          });
        } else {
          this.formTypeData.push({
            id: element.id,
            type: element.type,
            image: element.image,
            displayType: findTemplateType.templateSubType,
            entityData: suggestionFile,
            isCustomImg: true,
            img: element.image,
          });
        }
      });
      this.formTypeData?.forEach((form) => {
        const matchTemplateExist = this.linkedTemplate.find((template) => template.vault_form_type === form.type);
        form.linked = matchTemplateExist ? true : false;
      });
      this.suggestionData = [
        {
          type: SuggestionType.USER,
          userData: [],
          vaultFormTypeData: [],
        },
        {
          type: SuggestionType.ENTITY,
          userData: [],
          vaultFormTypeData: this.formTypeData,
        },
      ];
      this.is_Group = true;

      this.data?.formsList?.filter((x) => x.search_tokens != null);
      let list = [];
      if (this.data?.filter_with == 'type_template') {
        list = this.data?.formsList?.filter((x) => x.type_template?.toLowerCase().includes(this.data?.type_template?.toLowerCase()));
      } else {
        list = this.data?.formsList?.filter((x) => x.organization_section?.toLowerCase().includes(this.data?.type_template?.toLowerCase()));
      }
      this.group_templateConfigurationList = [];
      this.group_templateConfigurationList.push({
        label: this.data.label,
        id: 23,
        img: this.data.icon_path,
        isGroup: true,
        displayType: 'Add New ' + this.data.type_template,
        isCustomImg: true,
        groupList: list,
      });
    }
    this.isUnLinkedFileLoading = false;
    this.isLinkedFileLoading = false;
    this.cd.detectChanges();
  }
  deleteTemplate(event) {
    let vault_user_form_uploads_id = this.data?.vault_user_form_uploads_id ? this.data?.vault_user_form_uploads_id : event.vault_user_form_uploads_id;
    this.subscription.add(
      this.documentService
        .deleteUserFormAssociation(
          this.currentUserId,
          this.currentFormId,
          event.linked_form_id ? event.linked_form_id : event.formid,
          vault_user_form_uploads_id
        )
        .subscribe((result) => {
          const linkingType =
            this.data.type == 'Physical Location'
              ? 'physical_location'
              : this.data.type == 'Password Location'
              ? 'password_ocation'
              : this.data.type == 'SecuredBy'
              ? 'SecuredBy'
              : this.data.type == 'LoansSecured'
              ? 'LoansSecured'
              : this.data.type;
          this.trackEventsInMixPanel([
            {
              eventName: 'remove',
              data: {
                form_name: event.form_name,
                template_name: this.data.formName,
                vault_form_type: event.vault_form_type,
                type_template: this.data.type_template,
              },
            },
          ]);
          this.getLinkedForms();

          this.cd.markForCheck();
        })
    );
  }
  viewModal(data: { file; event?: any }) {
    let path = data.event.path || (data.event.composedPath && data.event.composedPath());
    if (
      path[1].id !== 'toggleMoreWrapper' &&
      path[1].id !== 'checkbox-input-select' &&
      path[1].id !== 'toggleMore' &&
      path[1].classList[0] !== 'see-more__popup' &&
      path[1].classList[0] !== 'popup__wrapper' &&
      path[2].id !== 'kinnect-avatar' &&
      path[1].classList[0] !== 'share-from-stats' &&
      path[0].classList[0] !== 'share-from-stats' &&
      path[0].classList[0] !== 'not-shared-button' &&
      path[0].classList[0] !== 'checkbox-input' &&
      path[1].classList[0] !== 'mat-checkbox-layout' &&
      path[1].classList[1] !== 'Comment-notes-card'
    ) {
      const dialogOpen = this.dialog.open(AddDocumentComponent, {
        disableClose: true,
        data: { file: data.file, mode: 'edit', isintelligent: false, isfileListLoad: true },
        panelClass: 'full-window-dialog-add-document',
        autoFocus: false,
      });
      this.subscription.add(
        dialogOpen.afterClosed().subscribe(() => {
          this.dialogEventService.triggerRefresh();
        })
      );
    }
  }

  editFeedData(item) {
    const childDialog = this.dialog.open(EditMxPlayerComponent, {
      height: '100%',
      data: {
        selectedFileList: [],
        currentuserId: this.currentUserId,
        currentFormId: item.id ? item.id : item.vault_user_form_id,
        hide_checkbox_section: true,
        formName: item.form_name,
      },
      panelClass: 'full-window-dialog',
    });
    this.subscription.add(
      childDialog.afterClosed().subscribe(
        (data) => {
          this.getLinkedForms();
        },
        (error) => {}
      )
    );
  }

  reconnect(item) {
    item.user_id = this.currentUserId;
    const dialogRef: MatDialogRef<ConnectToMxComponent> = this.mxTaskbarService.openMxDialog(ConnectToMxComponent, {
      width: '400px',
      maxWidth: this.screenWidth < 480 ? '90vw' : '80vw',
      autoFocus: false,
      data: {
        currentValutUserId: this.currentUserId,
        isUpdate: true,
        stop_form_creation: true,
        account: item,
      },
    });
    this.subscription.add(
      dialogRef.afterClosed().subscribe((val) => {
        if (val.success) this.getLinkedForms();
      })
    );
  }
  trackEventsInMixPanel(events: { eventName: EventNames; data?: any }[]) {
    this.userService.trackEventsInMixPanel(events).then((response) => {});
  }
  handleData(data) {
    return { ...data, isUpdatedUi: true };
  }

  onLinkedTemplateSelectionChange(event: { template: any; index: number; isChecked: boolean }) {
    this.linkedTemplateSelectionChange.emit({
      ...event,
      linkType: this.selectedLinkType,
    });
    this.cd.detectChanges();
  }

  clearSelections() {
    if (this.linkedTemplateList) {
      this.linkedTemplateList.clearSelections();
    }
    this.cd.detectChanges();
  }

  removeTemplate(template: any) {
    if (this.linkedTemplateList) {
      this.linkedTemplateList.removeTemplate(template);
    }
  }
}
